import React from 'react'
import {Route, withRouter} from 'react-router-dom'
import renderMergedProps from './renderMergedProps';

const PropsRoute = ({ component, ...rest }) => {
    return (
        <Route {...rest} render={ routeProps => {
            return renderMergedProps(component, routeProps, rest);
        }}/>
    );
};

export default withRouter(PropsRoute);
